export default __webpack_public_path__ + "static/media/KaushanScript-Regular.a668b3d9.ttf";